class LoadMore {
  constructor() {
    document.addEventListener('click', (event) => {
      const button = event.target.closest('[data-load-more-button]');
      if (!button) return;
      this.handleClick(button);
    });
  }

  handleClick(button) {
    const url = button.getAttribute('data-next-url');
    if (!url || button.disabled) return;

    button.disabled = true;
    button.textContent = 'Loading...';

    fetch(url)
      .then((response) => response.text())
      .then((responseText) => this.render(responseText, button))
      .catch((error) => {
        console.error('Load more error:', error);
        button.disabled = false;
        button.textContent = 'View More';
      });
  }

  render(responseText, button) {
    const parsed = new DOMParser().parseFromString(responseText, 'text/html');
    const currentGrid = document.getElementById('product-grid');
    const newGrid = parsed.getElementById('product-grid');
    if (!currentGrid || !newGrid) return;

    // The fetched page only contains that page's products (e.g. page 2 = next 4 items),
    // NOT the cumulative total — so just append everything it returned.
    const itemsToAppend = Array.from(newGrid.children);

    itemsToAppend.forEach((item, index) => {
      item.classList.add('load-more__item');
      currentGrid.appendChild(item);
      requestAnimationFrame(() => {
        setTimeout(() => {
          item.classList.add('load-more__item--visible');
        }, index * 60);
      });
    });

    // Swap the whole load-more wrapper (updates count, progress bar, next button/removal)
    const currentWrapper = document.querySelector('[data-load-more]');
    const newWrapper = parsed.querySelector('[data-load-more]');
    if (currentWrapper && newWrapper) {
      currentWrapper.replaceWith(newWrapper);
    } else if (currentWrapper) {
      currentWrapper.remove();
    }
  }
}

function initLoadMore() {
  if (window.__loadMoreInit) return;
  window.__loadMoreInit = true;
  new LoadMore();
}

document.addEventListener('DOMContentLoaded', initLoadMore);